// Editorial-driven blog content.
// To add a new post: prepend an object to POSTS with slug, title, excerpt, date, readTime, tags, content (markdown string).
// Newest first — the list page sorts by date but insertion order matters if two dates match.

export const POSTS = [
  {
    slug: "the-cost-of-vanity-metrics",
    title: "The Cost of Vanity Metrics in Fintech Acquisition",
    excerpt:
      "Impressions don't fund payroll. A field note on why we killed our top-of-funnel dashboards and rebuilt the North Star around funded traders.",
    date: "2026-02-04",
    readTime: "6 min read",
    tags: ["Performance", "Attribution", "Fintech"],
    author: "Himanshu Oberoi",
    content: `Every quarter, a new dashboard tries to convince someone in leadership that the machine is working.

Cost per lead is down. Click-through rate is up. Reach is trending. The slide is green. The revenue is flat.

## What we were actually optimising for

At [Capital.com](https://capital.com), we spent a full quarter tracking every touch — every hover, every scroll depth, every soft-conversion micro-signal. It gave us a beautifully instrumented funnel and an *appallingly* misleading picture of the business.

The problem wasn't the data. The problem was the definition of *conversion*.

- A registration is not a funded account.
- A funded account is not a *qualified* funded account.
- A qualified funded account is not a repeat trader.

Between each of those steps sits a 40–70% drop-off that no upstream metric will ever surface.

## The rebuild

We collapsed the reporting stack to three tiers:

1. **Spend cadence** — daily, per channel, per market. Diagnostic only.
2. **Qualified funded traders (QFTs)** — the *only* KPI attached to compensation.
3. **LTV : CAC by cohort quarter** — the truth-teller.

Everything else — CPL, CTR, CPM — became debug logs. Not decisions.

## The uncomfortable outcome

Half of what we thought was *working* wasn't. Facebook remarketing, in particular, had been quietly claiming credit for organic search intent for eighteen months.

Cutting it produced a 22% *increase* in QFTs at 34% lower blended CAC.

That's the cost of vanity metrics. Not just the media dollars — the *strategic time* spent optimising for the wrong verb.

---

*If your team is stuck in a similar loop, [get in touch](/#contact) — I write about this every few weeks.*`,
  },
];

export function getPostBySlug(slug) {
  return POSTS.find((p) => p.slug === slug) || null;
}

export function getAllPostsSorted() {
  return [...POSTS].sort((a, b) => (a.date < b.date ? 1 : -1));
}
